import styled, { keyframes } from "styled-components";
import { IoIosSave, IoMdCloseCircle } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { ErrorMessage } from "formik";
import TextInput from "../../components/TextInput";
import NumberInput from "../../components/NumberInput";

export const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

// Componente Loader para mostrar durante la carga
export const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

// Estilos para los componentes
export const DivFlexP1 = styled.div`
  margin-top: -5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormContainerP1 = styled.div`
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
  width: 100%;
`;

export const FormLabelP1 = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TextInputP1 = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const NumberInputP1 = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const RadioInputP1 = styled.input`
  margin-right: 10px;
`;

export const ErrorMessageP1 = styled.div`
  color: red;
  font-size: 0.875em;
`;

export const DivContenedorMax = styled.div`
  display: flex;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  height: auto;
  border-radius: 5px;

  @media screen and (max-width: 780px) {
    background-color: #fff;
  }
`;

export const Div = styled.div`
  border-radius: 15px;
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 5%;
  padding-left: 2%;
  padding-top: 110px;
  padding-bottom: 8%;
  position: relative;
  height: 100%;
  min-height: 900px;
  width: 1050px;
  max-width: 1050px;
  transition: opacity 0.3s ease;

  @media screen and (max-width: 780px) {
    height: auto;
    min-height: 100%;
    width: 100vw;
    margin-left: 0;
    padding-left: 10px;
    margin-right: 0;
    padding-right: 10px;
    max-width: 100%;
    height: 100vh;
    position: relative;
    padding-bottom: 5%;
    padding-top: 95px;
  }
`;

export const DivFlex = styled.div`
  margin-top: -5px;
  display: flex;
  gap: 24px;
  justify-content: center;
  align-items: flex-start;
  align-text: center;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormContainer = styled.div`
  padding: 20px;
  border-radius: 5px;
  width: 100%;
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;
  width: 100%;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const DivFlex2 = styled.div`
  margin-top: -5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const DivFlexP4 = styled.div`
  margin-top: -5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormContainerP4 = styled.div`
  padding: 20px;
  border-radius: 5px;
  width: 100%;
`;

export const FormGroupP4 = styled.div`
  margin-bottom: 15px;
  width: 100%;
`;

export const FormLabelP4 = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TextAreaP4 = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;

export const FieldP4 = styled(TextInput)`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const TableP4 = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  td {
    background-color: #fff;
  }
`;

export const ErrorMessageP4 = styled.div`
  color: red;
  font-size: 0.875em;
`;

export const DivFlexP5 = styled.div`
  margin-top: -5px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormContainerP5 = styled.div`
  padding: 20px;
  border-radius: 5px;
  width: 100%;
`;

export const FormLabelP5 = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TableP5 = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  td {
    background-color: #fff;
  }
`;

export const FieldP5 = styled(TextInput)`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const FieldP55 = styled(NumberInput)`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const ErrorMessageP5 = styled.div`
  color: red;
  font-size: 0.875em;
`;

export const DivForm = styled.div``;

export const Label = styled.label`
  font-weight: bold;
  margin-right: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
`;

export const ErrorMessageStyled = styled(ErrorMessage)`
  display: inline-block;
  color: red;
  margin-left: 3px;
`;

export const ButtonNext = styled.button`
  padding: 10px 20px;
  background-color: #42adea;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  margin-right: 0%;
  bottom: 2%;

  &:hover {
    background-color: #3592c8;
  }
`;

export const ButtonAtras = styled.button`
  padding: 10px 20px;
  background-color: #42adea;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  bottom: 2%;

  &:hover {
    background-color: #3592c8;
  }
`;

export const ButtonEnviar = styled.button`
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  bottom: 2%;
  background-color: #3cb371;

  &:hover {
    background-color: #359b62;
  }

  &:disabled {
    background-color: #e7e7e7;
    color: #a0a0a0;
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const DivError = styled.button`
  border: none;
  padding: 5px;
  color: black;
  height: auto;
  margin: 1%;
  bottom: 0%;
  background-color: salmon;
  border-radius: 5px;
  border: solid 1px;
  border-color: black;
`;

export const DivSinErrores = styled.div`
  border: none;
  padding: 5px;
  color: black;
  height: auto;
  margin: 1%;
  bottom: 0%;
  background-color: #3cb371;
  border-radius: 5px;
  border: solid 1px;
  border-color: black;
`;

export const DivButtons = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin-top: 0%;
  bottom: 75px;
  margin: 0px;

  @media screen and (max-width: 780px) {
    position: relative;
    bottom: 15%;
    margin-bottom: 10%;
    width: 100%;
  }
`;

export const DivContenedorError = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  bottom: 0;
  width: 95%;
`;

export const ImgReferencia = styled.img`
  display: ${({ visible }) => (visible ? "block" : "none")};
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100vw;
  height: 100vh;
  z-index: 1000000;
  object-fit: contain;
  background-color: #000000ee;
  cursor: pointer;
`;

export const ProgressBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;

  @media screen and (max-width: 780px) {
    margin-top: 2%;
    justify-content: center;
    align-items: center;
    width: auto;
  }
`;

export const StepProgress = styled.div`
  flex: 1;
  display: flex;

  @media screen and (max-width: 780px) {
    margin-bottom: 5%;
  }
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  animation: ${fadeAnimation} 0.5s ease-in-out;

  @media screen and (max-width: 780px) {
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
`;

export const Bullet = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active === "true" ? "#76c7c0" : "#e0e0df"};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.active === "true" ? "white" : "black")};
  font-weight: bold;
  z-index: 10;
  cursor: pointer;

  &:hover {
    background-color: #61a29c;
  }

  @media screen and (max-width: 780px) {
    margin-top: 10%;
  }
`;

export const StepTitle = styled.p`
  margin-top: 10px;

  @media screen and (max-width: 780px) {
    display: none;
    margin: 0;
    padding: 0;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export const SaveIcon = styled.button`
  padding: 7px;
  border-radius: 5px;
  border: none;
  position: absolute;
  left: 3%;
  margin-top: 55px;
  display: flex;
  align-items: center;
  background-color: #50aac5;
  transition: width 0.3s ease, height 0.3s ease;
  color: white;

  &:hover {
    background-color: #438da3;
    color: white;
  }

  &:disabled {
    background-color: #a0bcc5;
    color: #d3d3d3;
    cursor: not-allowed;

    &:hover {
      background-color: #a0bcc5;
      color: #d3d3d3;
    }
  }

  @media screen and (max-width: 780px) {
    padding: 10px;
    margin-top: 85px;
  }
`;

export const FechaTerminoIcon = styled.button`
  padding: 7px;
  border-radius: 5px;
  border: none;
  position: absolute;
  right: 3%;
  margin-top: 55px;
  display: flex;
  align-items: center;
  background-color: #eccc64;
  transition: width 0.3s ease, height 0.3s ease;
  color: black;

  @media screen and (max-width: 780px) {
    padding: 10px;
    margin-top: 85px;
  }
`;

export const Icon = styled(IoIosSave)`
  margin-right: 5px;
  font-size: 1.2rem;
`;

export const CheckIcon = styled(FaCheckCircle)`
  position: absolute;
  margin-left: -3%;
  margin-bottom: 20px;
  display: block;
  color: #22bb33;
  z-index: 10;
`;

export const CloseIcon = styled(IoMdCloseCircle)`
  position: absolute;
  margin-left: -3%;
  margin-bottom: 20px;
  display: block;
  color: #bb2124;
  z-index: 10;
`;

export const PI = styled.p`
  margin-top: 1%;
  width: 90%;
  font-size: 20px;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
  text-align: justify;

  @media screen and (max-width: 780px) {
    font-size: 18px;
    width: 95%;
  }
`;

export const ButtonDownload = styled.button`
  padding: 10px 20px;
  background-color: #04aa6d;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #048254;
  }
`;

export const DivNavbar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #f1f1f1;
  padding: 0px;
  z-index: 999;
  margin-bottom: 50%;
`;

export const Asterisk = styled.span`
  color: red;
  margin-left: 4px;
`;
